// Identifiant de session unique PAR ONGLET. `sessionStorage` est isolé par
// onglet (contrairement à localStorage), donc deux onglets — même compte — ont
// deux ids différents. Sert au verrou « fiche ouverte » par session : le 1er
// onglet à ouvrir une fiche la détient ; les autres (y compris du même user)
// sont en lecture seule.
const OPENER_KEY = "svp_opener_id"

export const getOpenerId = () => {
	let id = sessionStorage.getItem(OPENER_KEY)
	if (!id) {
		id =
			window.crypto && window.crypto.randomUUID
				? window.crypto.randomUUID()
				: `${Date.now()}-${Math.random().toString(36).slice(2)}`
		sessionStorage.setItem(OPENER_KEY, id)
	}
	return id
}
